import { cacheConfigByMode } from '../constants/cacheConfigByMode'
import { retryConfigByMode } from '../constants/retryConfigByMode'
import type { ApiConfig } from '../types/apiConfig'

export const getBaseApiConfigValue = (config: ApiConfig) => {
	return {
		cache: cacheConfigByMode[config.cacheTimeMode],
		retry: retryConfigByMode[config.retryMode]
	}
}
